<template>
    <v-container max-width="100%" style="margin-top: 2%">

    <template>
      <v-alert
        type="error"
        dismissible
        v-model="alertForm"
        dark
      >{{ alertFormMessage }}</v-alert>
    </template>

      <v-container class="toolbar__container">
        <v-form ref="form" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="3" md="2">
              <v-autocomplete
                v-model="idEmpresaSelected"
                :items="empresas"
                item-text="razao_social"
                item-value="id_empresa"
                clearable
                :label="$t('employee.headers.company')"
              ></v-autocomplete>
            </v-col>
            <!-- adicionar unidade -->
            <v-col cols="12" sm="6" md="3">
              <MultiplaEscolha
                ref="unidadesSelect"
                lazy
                get-url="getUnidadeslazy"
                :items="semUnidadeOption"
                v-bind:selected-items.sync="unidadesSelecionadas"
                text="descricao_unidade"
                value="id_unidade"
                :label="$t('nav.registration.units')"
                :max-items="2"
              />
            </v-col>
            <!-- termina unidade -->
            <v-col cols="12" sm="4" md="3">
              <v-datetime-picker
                :label="$t('speedReport.startDate')"
                v-model="dti"
                :time-picker-props="timeProps"
                :date-picker-props="dtiProps"
                :text-field-props="textFieldProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker
              :label="$t('speedReport.endDate')"
              v-model="dtf"
              :time-picker-props="timeProps"
              :date-picker-props="dtfProps"
              :text-field-props="textFieldProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="1" md="1" align="end">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="populaRelatorio"
                  style="margin-bottom: 5px;"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("operation.search") }}</span>
            </v-tooltip>
          </v-col>
          </v-row>
          <v-row>
              <v-col cols="12" sm="4" md="4">
                  <MultiplaEscolha
                      ref="veiculosSelect"
                      lazy
                      get-url="getVeiculoslazy"
                      :request-data="lazySelectRequestData"
                      v-bind:selected-items.sync="idVeiculosSelected"
                      text="numero_ordem"
                      value="id_veiculo"
                      :label="$t('tripOperation.headers.vehicleNumber')"
                      :max-items="2"
                  />
              </v-col>
              <v-col cols="12" sm="4" md="4">
                  <MultiplaEscolha
                      ref="linhasSelect"
                      lazy
                      get-url="getLinhaslazy"
                      :request-data="lazySelectRequestData"
                      v-bind:selected-items.sync="idLinhasSelected"
                      text="cod_linha"
                      value="id_linha"
                      :label="$t('tripOperation.line')"
                      :max-items="2"
                  />
              </v-col>
              <v-col cols="12" sm="4" md="4">
                  <MultiplaEscolha
                      ref="cercasSelect"
                      lazy
                      get-url="getCercaslazy"
                      :request-data="lazySelectRequestData"
                      v-bind:selected-items.sync="idCercasSelected"
                      text="nome_cerca"
                      value="id_cerca"
                      :label="$t('operation.notificationHeaders.geofence')"
                      :max-items="2"
                  />
              </v-col>
          </v-row>
          <v-row>
              <v-col cols="12" sm="6" md="6">
                  <v-slider
                      v-model="limiteVelocidade"
                      :label="$t('geofence.maxSpeed')"
                      color="primary"
                      :max="150"
                      thumb-label="always"
                      style="padding-top: 30px;"
                  ></v-slider>
              </v-col>
              <v-col cols="12" sm="1" md="1">
                  <v-text-field
                      v-model="limiteVelocidade"
                      :max="150"
                      type="number"
                      hide-spin-buttons
                      solo-inverted
                  ></v-text-field>
              </v-col>
          </v-row>
        </v-form>
      </v-container>

      <v-data-table
          :headers="headers"
          :items="agregado"
          :server-items-length="totalAgregado"
          :options.sync="tableOptions"
          :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
          dense
          class="elevation-7"
          locale="pt"
          :loading="loading"
          :loading-text="$t('system.messages.loading')"
          item-key="key"
          :expanded.sync="expandidos"
          show-expand
          :single-expand="true"
          style="border-radius: 10px; margin-top: 10px;"
      >
          <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="margin: 0;padding: 5px;">
                  <v-data-table
                      :headers="[{text: $t('speedReport.dateTime'), value: 'dt_posicao_extenso', sortable: false}, {text: $t('geofence.speed'), value: 'velocidade', sortable: false}]"
                      :items="detalhe(item).items"
                      :server-items-length="detalhe(item).total"
                      :loading="detalhe(item).loading"
                      :footer-props="{ itemsPerPageOptions: [10, 50, 100] }"
                      dense
                      locale="pt"
                      @update:options="(opts) => carregaPosicoes(item, opts)"
                  >
                  </v-data-table>
              </td>
          </template>

          <template v-slot:top>
          <v-toolbar flat color="white" style="border-radius: 10px">
              <v-toolbar-title style="color: #4a4a4a">
                  {{ $t('speedReport.Report') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>

              <ExportTableCSV
                  title="velocidade"
                  :content="agregado"
                  :content-loader="loadItemsForExport"
                  defer-processing
                  :headers="headers"
              />

              <ExportTablePdf
                  :title="$t('speedReport.Report')"
                  :content="agregado"
                  :content-loader="loadItemsForExport"
                  defer-processing
                  :headers="headers"
                  filename="relvelocidade"
                  >
              </ExportTablePdf>
          </v-toolbar>
          </template>
      </v-data-table>
  </v-container>
</template>

<script>

import apiController from '@/utils/apiController';
import DateUtils from "../utils/dateutils";
import { fetchAllServerPagesForExport } from '@/utils/serverTablePagination';
import ExportTableCSV from "./ExportTableCSV.vue";
import ExportTablePdf from "./ExportTablePdf.vue";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

function chaveGrupo(item) {
  return [item.id_veiculo, item.matricula_motorista, item.id_linha].join('|');
}

export default {
  components: {
      ExportTableCSV,
      ExportTablePdf,
      MultiplaEscolha
  },
  data: () => ({
      alertForm: false,
      alertFormMessage: "",
      user: null,
      token: null,
      config: null,
      loading: false,
      agregado: [],
      totalAgregado: 0,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['numero_ordem'],
        sortDesc: [false],
      },
      // Filtros do formulario no momento da busca: paginar/ordenar/expandir não
      // pode pegar alteracoes ainda não aplicadas pelo botao de busca.
      filtrosAplicados: null,
      // Posicoes das linhas expandidas, por chave de grupo.
      detalhes: {},
      expandidos: [],
      requisicaoAtual: 0,
      empresas: [],
      idCercasSelected: [],
      idLinhasSelected: [],
      unidadesSelecionadas: [],
      dti: null,
      dtf: null,
      idEmpresaSelected: null,
      idVeiculosSelected: [],
      timeProps: {
        useSeconds: true,
      },
      formValidado: false,
      limiteVelocidade: 50,
  }),
  computed: {
    today() {
      return new Date().toISOString().substring(0,10);
    },
    headers() {
      return [
        { text: this.$t('vehicle.id'), value: 'id_veiculo', align: ' d-none' },
        { text: this.$t('tripOperation.vehicle'), value: 'numero_ordem' },
        { text: this.$t('operation.notificationHeaders.line'), value: 'cod_linha' },
        { text: this.$t('employee.headers.registration'), value: 'matricula_motorista' },
        { text: this.$t('tripOperation.driver'), value: 'nome_motorista' },
        { text: this.$t('speedReport.headers.averageSpeed'), value: 'velocidade_media' },
        { text: this.$t('speedReport.headers.maxSpeed'), value: 'velocidade_maxima' },
      ];
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      };
    },
    dtiProps() {
      return {
        max: this.today,
        rules: [this.dtRules]
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
        } else {
          min = this.dti.toISOString().substring(0,10);
        }
      }
      return {
        min: min,
        rules: [this.dtRules]
      }
    },
    semUnidadeOption() {
      if (!this.isAdminUsuario) {
        return [];
      }
      return [
        {
          id_unidade: -1,
          descricao_unidade: 'Sem Unidade',
          cod_unidade: 'SU',
        },
      ];
    },
    isAdminUsuario() {
      const u = this.user;
      if (!u) return false;
      return (
        Number(u.is_superadmin) === 1 ||
        u.is_superadmin === true ||
        Number(u.is_administrador) === 1 ||
        u.is_administrador === true
      );
    },
    lazySelectRequestData() {
      const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
      const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
      const temSemUnidade = unidades.includes(-1);
      if (reais.length === 1 && !temSemUnidade) {
        return { id_unidade: reais[0] };
      }
      if (temSemUnidade && reais.length === 0) {
        return { id_unidade: -1 };
      }
      return {};
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    unidadesSelecionadas() {
      this.idVeiculosSelected = [];
      this.idLinhasSelected = [];
      this.idCercasSelected = [];
      this.resetLazySelectRef('veiculosSelect');
      this.resetLazySelectRef('linhasSelect');
      this.resetLazySelectRef('cercasSelect');
    },
    idLinhasSelected() {
      this.onLinhaChanged();
    },
    idCercasSelected() {
      this.onCercaChanged();
    },
    tableOptions: {
      handler(novo, antigo) {
        if (!this.filtrosAplicados || !antigo) return;
        const mudou = ['page', 'itemsPerPage', 'sortBy', 'sortDesc']
          .some((k) => JSON.stringify(novo[k]) !== JSON.stringify(antigo[k]));
        if (mudou) {
          this.carregaAgregado();
        }
      },
      deep: true,
    },
  },
  created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
  },
  methods: {
      resetLazySelectRef(name) {
        const ref = this.$refs[name];
        if (ref && typeof ref.resetData === 'function') {
          ref.resetData();
        }
      },
      initialize() {
        this.getConfig();
        this.populaEmpresas();
      },
      getConfig() {
        apiController.request(apiController.endpoints.getallConfig, {
          onSuccess: (response) => {
            this.config = response.data[0];
            [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
          },
        });
      },
      populaEmpresas() {
        apiController.request(apiController.endpoints.getallEmpresas, {
          onSuccess: (response) => {
            this.empresas = response.data || [];
          },
        });
      },
      populaRelatorio() {
          this.$refs.form.validate();

          if (!this.formValidado) {
            return;
          }

          // Sem seleção explícita o backend já restringe ao escopo do usuário;
          // não resolver "todos os ids" dos selects aqui (IN gigante e, com unidade
          // selecionada, lista vazia que zerava o relatório).
          this.filtrosAplicados = {
            idveiculos: this.idVeiculosSelected.map(Number),
            idlinhas: this.idLinhasSelected.map(Number),
            idcercas: this.idCercasSelected.map(Number),
            idunidades: this.unidadesSelecionadas.map(Number),
            idempresa: this.idEmpresaSelected,
            limite_velocidade: Number(this.limiteVelocidade) || 0,
            dti: DateUtils.getDateSQLFormatted(this.dti),
            dtf: DateUtils.getDateSQLFormatted(this.dtf),
          };
          this.detalhes = {};
          this.expandidos = [];
          if (this.tableOptions.page !== 1) {
            // O watcher de tableOptions dispara a carga.
            this.tableOptions = { ...this.tableOptions, page: 1 };
            return;
          }
          this.carregaAgregado();
      },
      paramsAgregado(page, itemsPerPage) {
        const { sortBy, sortDesc } = this.tableOptions;
        return {
          ...this.filtrosAplicados,
          page,
          rowsPerPage: itemsPerPage,
          total: 'true',
          sortBy: (sortBy || []).join(','),
          sortDesc: (sortDesc || []).map((d) => (d ? 'true' : 'false')).join(','),
        };
      },
      async carregaAgregado() {
        if (!this.filtrosAplicados) return;
        const { page, itemsPerPage } = this.tableOptions;
        const requisicao = ++this.requisicaoAtual;
        this.loading = true;
        try {
          const response = await apiController.request(apiController.endpoints.getRelatoriovelocidade, {
            data: this.paramsAgregado(page, itemsPerPage > 0 ? itemsPerPage : 100),
          });
          // Resposta de uma busca/página já substituída.
          if (requisicao !== this.requisicaoAtual) return;
          const data = response.data || {};
          this.agregado = (data.items || []).map((item) => ({ ...item, key: chaveGrupo(item) }));
          this.totalAgregado = Number(data.total) || 0;
        } catch (_err) {
          if (requisicao !== this.requisicaoAtual) return;
          this.agregado = [];
          this.totalAgregado = 0;
        } finally {
          if (requisicao === this.requisicaoAtual) {
            this.loading = false;
          }
        }
      },
      async loadItemsForExport(onProgress) {
        if (!this.filtrosAplicados) {
          return [];
        }
        return fetchAllServerPagesForExport({
          fetchPage: async (params) => {
            const response = await apiController.request(apiController.endpoints.getRelatoriovelocidade, {
              data: this.paramsAgregado(params.page, params.rowsPerPage),
              silent: true,
            });
            return response && response.data;
          },
          state: { total: this.totalAgregado },
          onProgress,
        });
      },
      detalhe(item) {
        return this.detalhes[item.key] || { items: [], total: 0, loading: true, page: null, itemsPerPage: null };
      },
      async carregaPosicoes(item, opts) {
        if (!this.filtrosAplicados) return;
        const page = opts.page;
        const itemsPerPage = opts.itemsPerPage > 0 ? opts.itemsPerPage : 100;
        const atual = this.detalhe(item);
        if (atual.page === page && atual.itemsPerPage === itemsPerPage) return;
        this.$set(this.detalhes, item.key, { ...atual, loading: true, page, itemsPerPage });
        try {
          const response = await apiController.request(apiController.endpoints.getRelatoriovelocidade, {
            data: {
              ...this.filtrosAplicados,
              page,
              rowsPerPage: itemsPerPage,
              total: 'true',
              detalhe: {
                id_veiculo: item.id_veiculo,
                matricula_motorista: item.matricula_motorista,
                id_linha: item.id_linha,
              },
            },
          });
          const data = response.data || {};
          this.$set(this.detalhes, item.key, {
            items: data.items || [],
            total: Number(data.total) || 0,
            loading: false,
            page,
            itemsPerPage,
          });
        } catch (_err) {
          this.$set(this.detalhes, item.key, { items: [], total: 0, loading: false, page: null, itemsPerPage: null });
        }
      },
      onCercaChanged() {
        if (this.idCercasSelected.length === 0) return;
        const ref = this.$refs.cercasSelect;
        if (!ref || typeof ref.getCachedSelectedItem !== 'function') return;
        for (const id of this.idCercasSelected) {
          const item = ref.getCachedSelectedItem(id);
          if (item && item.velocidade_maxima) {
            this.limiteVelocidade = item.velocidade_maxima;
            return;
          }
        }
      },
      onLinhaChanged() {
        if (this.idLinhasSelected.length === 0) return;
        const ref = this.$refs.linhasSelect;
        if (!ref || typeof ref.getCachedSelectedItem !== 'function') return;
        for (const id of this.idLinhasSelected) {
          const item = ref.getCachedSelectedItem(id);
          if (item && item.velocidade_maxima) {
            this.limiteVelocidade = item.velocidade_maxima;
            return;
          }
        }
      },
  },
}
</script>
